const rankingItems = [
  { rank: 1, title: '流浪地球3', type: '电影', tag: '科幻', hot: '9.7', trend: 'up' },
  { rank: 2, title: '庆余年2', type: '剧集', tag: '古装', hot: '9.5', trend: 'up' },
  { rank: 3, title: '繁花', type: '剧集', tag: '年代', hot: '9.4', trend: 'stay' },
  { rank: 4, title: '孤注一掷', type: '电影', tag: '犯罪', hot: '9.3', trend: 'up' },
  { rank: 5, title: '狂飙', type: '剧集', tag: '涉案', hot: '9.2', trend: 'stay' },
  { rank: 6, title: '长津湖之水门桥', type: '电影', tag: '战争', hot: '9.1', trend: 'down' },
  { rank: 7, title: '三体', type: '剧集', tag: '科幻', hot: '9.0', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门榜单</h2>
          <p className="mt-2 text-sm text-foreground-500">全网热播影视排行榜，实时更新热度排名</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 px-4 md:px-6 py-3.5 border-b border-background-100 last:border-b-0 hover:bg-background-100/50 transition-colors cursor-pointer"
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-md text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-800 truncate">{item.title}</span>
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-md whitespace-nowrap">{item.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.type}</span>
                </div>

                <div className="flex items-center gap-1.5 flex-shrink-0">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-xs text-primary-500"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-xs text-foreground-400"></i>}
                  {item.trend === 'stay' && <i className="ri-subtract-line text-xs text-foreground-400"></i>}
                  <span className="text-sm font-bold text-primary-500">{item.hot}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}